import { render, staticRenderFns } from "./LoginRedirect.vue?vue&type=template&id=a826f3b0"
import script from "./LoginRedirect.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginRedirect.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports